var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 253,
    viewBox: "0 0 186 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 186,
    height: 253
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.7601 0C80.5787 0 68.5165 2.39939 57.2624 7.06102C46.0082 11.7226 35.7824 18.5552 27.1688 27.1688C18.5552 35.7824 11.7226 46.0081 7.06094 57.2623C2.39931 68.5164 0 80.5785 0 92.7599C0 141.752 82.6332 245.38 86.1776 249.851C86.9691 250.835 87.9714 251.629 89.1107 252.174C90.25 252.719 91.4971 253.001 92.7601 253C94.0231 253.001 95.2702 252.719 96.4095 252.174C97.5488 251.629 98.5512 250.835 99.3426 249.851C102.887 245.38 185.52 141.752 185.52 92.7599C185.52 80.5785 183.121 68.5164 178.459 57.2623C173.798 46.0081 166.965 35.7824 158.351 27.1688C149.738 18.5552 139.512 11.7226 128.258 7.06102C117.004 2.39939 104.942 0 92.7601 0ZM92.7601 118.053C83.815 118.053 75.2363 114.499 68.9111 108.174C62.586 101.849 59.0325 93.2703 59.0325 84.3252C59.0424 75.3865 62.6001 66.8173 68.9242 60.5001C75.2483 54.183 83.8214 50.6347 92.7601 50.6347C97.1893 50.6347 101.575 51.5071 105.667 53.202C109.759 54.897 113.477 57.3814 116.609 60.5133C119.741 63.6452 122.225 67.3631 123.92 71.4552C125.615 75.5472 126.488 79.9329 126.488 84.3621C126.488 93.3072 122.934 101.886 116.609 108.211C110.284 114.536 101.705 118.09 92.7601 118.09V118.053Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.535156 -0.536133H186.022V253.526H-0.535156V-0.536133Z",
    fill: "#969696"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.2a6bcc18823b0ab02a3e9bd9feba00a4.svg";
export { ForwardRef as ReactComponent };